
import {
  defineComponent,
  ref,
  computed,
} from '@vue/composition-api';
import { FCCard, IconButton } from '@fc/angie-ui';
import FCSwiper from '~/components/FCSwiper.vue';
import Section from '~/components/v5/Section.vue';
import FCImage from '~/components/FCImage.vue';
import { isMobileEffect } from '~/effects/matchMedia';

const boxingCards = [
  {
    id: 1,
    tag: 'Meet Our Trainers',
    heading: 'Real Fighters, Real Coaching',
    image: 'https://a.storyblok.com/f/152150/3648x5472/1a41b94550/studio2_shoot-330.jpg',
    imageAlt: 'Man in a tank top and cap practicing a boxing stance in a well-lit gym, with focus and determination.',
    linkToSection: { path: '/the-system', hash: '#system-page__coaches' },
    trackingId: 'real_fighters_real_coaching',
  },
  {
    id: 2,
    tag: 'Explore Our Library',
    heading: 'Interactive learning modules + Ala Carte workouts',
    image: 'https://a.storyblok.com/f/152150/936x1162/fe98a82468/group-1533208268.jpg',
    imageAlt: 'A dark-themed interface showing a timeline of boxing programs, with sections for beginner, intermediate, and advanced levels.',
    linkToSection: { path: '/the-system', hash: '#system-page__programming' },
    trackingId: 'interactive_learning_modules',
  },
  {
    id: 3,
    tag: 'Explore the FC App Features',
    heading: 'AI Motion Technology that keeps you accountable',
    image: 'https://a.storyblok.com/f/152150/936x1162/7a21703c53/form-image-2x.jpg',
    imageAlt: 'Person in dark room boxing a punching bag, wearing white gloves. Screen displays "Perfect!" with checkmarks and numbers "3-2."',
    linkToSection: { path: '/the-system', hash: '#the-tech-section' },
    trackingId: 'ai_motion_technology',
  },
  {
    id: 4,
    tag: 'Explore the Equipment',
    heading: 'Premium Gear Designed for Your Home',
    image: 'https://a.storyblok.com/f/152150/3887x3887/c76a1b4a37/monica_room.jpg',
    imageAlt: 'A person in athletic wear practices boxing with a punching bag in a sunlit living room, with a TV displaying a workout video.',
    linkToSection: { path: '/the-system', hash: '#the-equipment-section' },
    trackingId: 'premium_home_gear',
  },
];

const kickboxingCards = [
  {
    id: 5,
    tag: 'Meet Our Trainers',
    heading: 'Real Fighters, Real Coaching',
    image: 'https://a.storyblok.com/f/152150/3415x3186/180ec8301e/studio2_shoot-285.jpg',
    imageAlt: 'A woman in athletic wear practices a high kick in a boxing ring, with an American flag in the background.',
    linkToSection: { path: '/the-system', hash: '#system-page__coaches' },
    trackingId: 'real_fighters_real_coaching',
  },
  {
    id: 6,
    tag: 'Explore Our Library',
    heading: 'Interactive learning modules + Ala Carte workouts',
    image: 'https://a.storyblok.com/f/152150/936x1162/fe98a82468/group-1533208268.jpg',
    imageAlt: 'A dark-themed interface showing a timeline of boxing programs, with sections for beginner, intermediate, and advanced levels.',
    linkToSection: { path: '/the-system', hash: '#system-page__programming' },
    trackingId: 'interactive_learning_modules',
  },
  {
    id: 7,
    tag: 'Explore the FC App Features',
    heading: 'AI Motion Technology that keeps you accountable',
    image: 'https://a.storyblok.com/f/152150/936x1162/d4a0661838/track-image-2x.jpg',
    imageAlt: 'A man in sportswear performs a high kick on a punching bag in a gym, with a digital display showing 91 strikes out of a 95 goal.',
    linkToSection: { path: '/the-system', hash: '#the-tech-section' },
    trackingId: 'ai_motion_technology',
  },
  {
    id: 8,
    tag: 'Explore the Equipment',
    heading: 'Premium Gear Designed for Your Home',
    image: 'https://a.storyblok.com/f/152150/5472x3648/b577c611ec/jess_website.jpg',
    imageAlt: 'A woman in pink athletic wear and boxing gloves kicks a FightCamp punching bag in a gym with dark walls and horizontal lights.',
    linkToSection: { path: '/the-system', hash: '#the-equipment-section' },
    trackingId: 'premium_home_gear',
  },
];

export default defineComponent({
  name: 'SystemSection',
  components: {
    FCCard,
    IconButton,
    FCSwiper,
    Section,
    FCImage,
  },
  setup() {
    const activeTab = ref('boxing');
    const setActiveTab = (tab: string) => {
      activeTab.value = tab;
    };

    const { $router } = useNuxtApp();
    const handleCardClick = (linkToSection: { path: string; hash: string }) => {
      $router.push(linkToSection);
    };

    const getTrackName = (heading: string) => `SystemSection__Card__${heading.trim().replace(/[,'’]/g, '').replace(/\s+/g, '_')}`;

    const isMobile = isMobileEffect();
    return {
      systemCards: computed(() => (activeTab.value === 'boxing' ? boxingCards : kickboxingCards)),
      activeTab,
      setActiveTab,
      isMobile,
      handleCardClick,
      getTrackName,
    };
  },
});
